/* jshint strict: true */
/* globals exports, jQuery */

/**
 * JavaScript version of "position: sticky"
 */
export default class SnapNavigation {
    constructor(element) {
        this.scroll = this.scroll.bind(this);
        this.docked = false;
        this._element = jQuery(element);
        this._initValue = -1;
        this.isNavbar = this._element.hasClass('navbar');

        this._initialize();
    }

    /**
     * @private
     */
    _initialize() {
        const snapBreakpoint = this._element.data('snap-breakpoint');
        if (snapBreakpoint && (jQuery(window).width() < parseInt(snapBreakpoint))) {
            return;
        }

        jQuery(window).scroll(this.scroll);
        window.setTimeout(this.scroll, 500);
    }

    /**
     * On-scroll callback
     */
    scroll() {
        const menu = this._element;

        if (!this.docked && (menu.offset().top - this.scrollTop() < 0)) { // Dock it
            if (this._initValue === -1) {
                this._initValue = menu.offset().top;
            }

            if (this.isNavbar) {
                menu.addClass('navbar-fixed-top');
            } else {
                menu.css('top', 0)
                    .css('position', 'fixed')
                    .addClass('docked');
            }
            this.docked = true;
        } else if (this.docked && this.scrollTop() <= this._initValue) { // Undock it
            if (this.isNavbar) {
                menu.removeClass('navbar-fixed-top');
            } else {
                menu.css('position', 'static')
                    .removeClass('docked');
            }
            this.docked = false;
        }
    }

    /**
     * Returns the scroll top
     *
     * @return {number}
     */
    scrollTop() {
        return document.body.scrollTop || document.documentElement.scrollTop;
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/SnapNavigation.js